import PropTypes from 'prop-types';

import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import { Box, Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ACTIVE_GROUPS_SECTION = 'active';
export const COMPLETED_GROUPS_SECTION = 'completed';

const GroupsPageHeader = ({ selectedSection, onSectionChange, onAddGroup }) => {
    const { t } = useTranslation();

    return (
        <Box
            component="header"
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'stretch', sm: 'center' },
                justifyContent: 'space-between',
                gap: 2,
                mb: 2
            }}
        >
            <ToggleButtonGroup
                exclusive
                value={selectedSection}
                onChange={(_, nextSection) => nextSection && onSectionChange(nextSection)}
                aria-label={t('groups.status_selector')}
                sx={{
                    width: { xs: '100%', sm: 'auto' },
                    height: 46,
                    p: 0.375,
                    gap: 0.5,
                    bgcolor: '#EEF2F5',
                    borderRadius: 1.5,
                    '& .MuiToggleButton-root': {
                        height: 39,
                        px: { xs: 1.5, sm: 2.5 },
                        border: 0,
                        borderRadius: '5px !important',
                        color: '#53636F',
                        fontSize: '0.82rem',
                        fontWeight: 700,
                        textTransform: 'none',
                        flex: { xs: 1, sm: 'initial' }
                    },
                    '& .MuiToggleButton-root.Mui-selected': {
                        color: '#FFFFFF',
                        bgcolor: '#1976D2',
                        boxShadow: '0 1px 3px rgba(25, 118, 210, 0.25)'
                    },
                    '& .MuiToggleButton-root.Mui-selected:hover': {
                        bgcolor: '#1565C0'
                    }
                }}
            >
                <ToggleButton value={ACTIVE_GROUPS_SECTION}>
                    {t('groups.sections_active')}
                </ToggleButton>
                <ToggleButton value={COMPLETED_GROUPS_SECTION}>
                    {t('groups.sections_completed')}
                </ToggleButton>
            </ToggleButtonGroup>

            <Button
                variant="contained"
                startIcon={<GroupAddOutlinedIcon />}
                onClick={onAddGroup}
                sx={{
                    minWidth: 205,
                    height: 46,
                    borderRadius: 1.5,
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                    textTransform: 'none'
                }}
            >
                {t('groups.add_new_group')}
            </Button>
        </Box>
    );
};

GroupsPageHeader.propTypes = {
    selectedSection: PropTypes.oneOf([ACTIVE_GROUPS_SECTION, COMPLETED_GROUPS_SECTION])
        .isRequired,
    onSectionChange: PropTypes.func.isRequired,
    onAddGroup: PropTypes.func.isRequired
};

export default GroupsPageHeader;
